export default __webpack_public_path__ + "42f1d2ef19cda328aa244cf34b1ec522.png";